import dynamic from "next/dynamic";
import SideBySideTitleParagraphConfig from "./side-by-side-title-paragraph-config";
import SideBySideTitleParagraphAdvancedConfig from "./side-by-side-title-paragraph-advanced-config";
const SideBySideTitleParagraphComponent = dynamic(()=>import("./side-by-side-title-paragraph-component"));
export default {
    SideBySideTitleParagraphComponent,
    SideBySideTitleParagraphConfig,
    SideBySideTitleParagraphAdvancedConfig
};
